import React from "react";
import styles from "./ToolCallInfoComponent.module.css";
import {AgentName, ToolCallDTO} from "../../../../../../../../../api/generated";
import {
    showCopiedSuccessfullyToastNotification
} from "../../../../../../../../elements/toastNotification/toastNotificationSlice";
import {useAppDispatch} from "../../../../../../../../../app/hooks";

export type ToolCallInfo = {
    isOpen: boolean
    toolCall: ToolCallDTO
    toolResponse: string
    isAgentHandover?: boolean
    targetAgent?: AgentName
}

interface ToolCallInfoProps {
    toolCallInfo: ToolCallInfo
}

export const ToolCallInfoComponent: React.FC<ToolCallInfoProps> = ({
                                                                       toolCallInfo
                                                                   }) => {

    const dispatch = useAppDispatch()

    const {
        isOpen,
        toolCall,
        toolResponse,
        isAgentHandover
    } = toolCallInfo;

    const parseJsonString = (value: string) => {
        try {
            return JSON.parse(value)
        } catch (e) {
            return value
        }
    }

    const getToolArguments = () => {
        if (!toolCall.arguments) {
            return {}
        }

        const parsedArguments = parseJsonString(toolCall.arguments)
        const normalizedArguments = typeof parsedArguments === "string"
            ? parseJsonString(parsedArguments)
            : parsedArguments

        return normalizedArguments && typeof normalizedArguments === "object"
            ? normalizedArguments
            : {}
    }

    const toolArguments = getToolArguments()

    const stringifyValue = (value: unknown) => {
        if (typeof value === "string") {
            const parsedValue = parseJsonString(value)
            if (parsedValue !== value && typeof parsedValue === "object" && parsedValue !== null) {
                return JSON.stringify(parsedValue, null, 2)
            }
            return value
        }

        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value, null, 2)
        }

        return String(value)
    }

    const copyAndShowToast = (value: string) => {
        if (value) {
            navigator.clipboard.writeText(value);
            dispatch(showCopiedSuccessfullyToastNotification());
        }
    }

    return <div className={`${styles.wrapper} ${isOpen ? styles.open : ""} ${isAgentHandover ? styles.handoverWrapper : ""}`}>
        <div className={styles.contentWrapper}>
            <div className={styles.toolNameWrapper}>
                <span className={styles.toolNameKey}>Actual Tool Name:</span>
                <span
                    className={styles.toolNameValue}
                    onClick={() => copyAndShowToast(String(toolCall.name))}
                >
                    {toolCall.name}
                </span>
            </div>
            <span className={styles.argumentsWrapperTitle}>Arguments</span>
            {Object.entries(toolArguments).map(([name, value]) => (
                <div key={name} className={styles.argumentRow}>
                    <div className={styles.argumentWrapper}>
                        <span className={styles.argumentTitle}>Name:</span>
                        <span
                            className={styles.argumentName}
                            onClick={() => copyAndShowToast(name)}
                        >
                            {name}
                        </span>
                    </div>
                    <div className={styles.argumentWrapper}>
                        <span className={styles.argumentTitle}>Value:</span>
                        <span
                            className={styles.argumentValue}
                            onClick={() => copyAndShowToast(stringifyValue(value))}
                        >
                            {stringifyValue(value)}
                        </span>
                    </div>
                </div>
            ))}
            <div className={styles.responseWrapper}>
                <span className={styles.argumentsWrapperTitle}>Response</span>
                <span
                    className={styles.toolResponse}
                    onClick={() => copyAndShowToast(toolResponse)}
                >
                    {toolResponse}
                </span>
            </div>
        </div>
    </div>
}
